import { TransitionMap } from '../types';

export const createTransitionMap = ({
  normalStyles,
  fullscreenStyles,
}: {
  normalStyles: Partial<CSSStyleDeclaration>;
  fullscreenStyles: Partial<CSSStyleDeclaration>;
}): TransitionMap => {
  return {
    NORMAL: {
      FULLSCREEN: {
        show: {
          startTransitionMessageType: { type: 'show-fullscreen', payload: {} },
          completeTransitionMessageType: { type: 'show-fullscreen-transition-complete' },
        },
        styles: () => fullscreenStyles,
      },
    },
    FULLSCREEN: {
      NORMAL: {
        show: {
          startTransitionMessageType: { type: 'show-embedded' },
          completeTransitionMessageType: { type: 'show-embedded-transition-complete' },
        },
        styles: () => normalStyles,
      },
    },
  };
};
